const productos = [
  { nombre: 'Remera de viaje de Quimsa Gris', precio: '$29.899,00' },
  { nombre: 'Remera de viaje de Quimsa Azul', precio: '$29.899,00' },
  { nombre: 'Musculosa Titular Quimsa Niño 23/24', precio: '$34.899,00' },
  { nombre: 'Short Alternativo de Quimsa 22/23', precio: '$32.899,00' },
];

const Tienda = () => {
  const tiendaURL = "https://adhoconline.com.ar/tienda/ols/search?keywords=quimsa&sortOption=descend_by_match";

  return (
    <main className="bg-[#001e3c] text-white min-h-screen p-6">
      <h1 className="text-4xl font-bold mb-6 border-b-2 border-white pb-2"> Tienda Oficial</h1>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {productos.map((p, i) => (
          <div
            key={i}
            className="bg-white text-[#202C5A] rounded-xl shadow-md p-6 flex flex-col justify-between"
          >
            <div>
              <h2 className="text-xl font-bold mb-2">{p.nombre}</h2>
              <p className="text-lg font-semibold mb-4">{p.precio}</p>
            </div>
            <a
              href={tiendaURL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-auto inline-block bg-[#FF69B4] text-white px-4 py-2 rounded text-sm text-center hover:bg-pink-600 transition"
            >
              Ver en tienda
            </a>
          </div>
        ))}
      </div>
    </main>
  );
};

export default Tienda;
